export default __webpack_public_path__ + "static/media/Lightsaber Obi-Wan ANH - Img - Wip 7_21.f912a388.jpg";